import { useState } from 'react';
import Reveal from './Reveal';
import SectionHeading from './SectionHeading';
import { upcomingPreviews } from '@/mocks/home';

function DigButton({ small = false }: { small?: boolean }) {
  const [dug, setDug] = useState(false);

  return (
    <button
      type="button"
      onClick={() => setDug((value) => !value)}
      className={`inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md font-label transition-colors ${
        small ? 'px-3 py-1.5 text-xs' : 'px-4 py-2.5 text-sm'
      } ${
        dug
          ? 'border border-primary-200 bg-primary-50 text-primary-700'
          : 'bg-foreground-950 text-background-50 hover:bg-foreground-800'
      }`}
    >
      <span className="flex h-4 w-4 items-center justify-center">
        <i className={dug ? 'ri-check-line' : 'ri-add-line'} />
      </span>
      {dug ? '已蹲一个' : '蹲一个'}
    </button>
  );
}

export default function UpcomingPreview() {
  const [featured, ...rest] = upcomingPreviews;

  return (
    <section id="next" className="bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-20">
        <Reveal>
          <SectionHeading
            index="01"
            title="下期爆料预告"
            subtitle="按「期」排布，先给标题和一句摘要，细节留到核验完成后补齐。"
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <article className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="relative aspect-[16/10] w-full overflow-hidden">
                <img
                  src={featured.cover}
                  alt={featured.title}
                  title="黑料最新 下期爆料 预告"
                  className="h-full w-full object-cover object-top"
                />
                <span className="absolute left-4 top-4 rounded-md bg-accent-500 px-3 py-1 font-label text-xs font-medium text-foreground-950">
                  {featured.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-3 font-label text-xs text-foreground-500">
                  <span className="font-medium text-primary-600">{featured.issue}</span>
                  <span className="h-3 w-px bg-background-300" />
                  <span>{featured.eta}</span>
                  <span className="h-3 w-px bg-background-300" />
                  <span>{featured.heat}</span>
                </div>
                <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  {featured.title}
                </h3>
                <p className="mt-3 font-body text-sm leading-relaxed text-foreground-700">
                  {featured.summary}
                </p>
                <div className="mt-6 flex flex-wrap items-center gap-3">
                  <DigButton />
                  <span className="font-label text-xs text-foreground-500">
                    已有 1,204 人蹲这期
                  </span>
                </div>
              </div>
            </article>
          </Reveal>

          <div className="lg:col-span-5">
            <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50">
              {rest.map((item, index) => (
                <Reveal key={item.id} delay={index * 90}>
                  <article
                    className={`flex gap-4 p-5 ${
                      index !== rest.length - 1 ? 'border-b border-background-200/70' : ''
                    }`}
                  >
                    <div className="hidden h-20 w-24 shrink-0 overflow-hidden rounded-md sm:block">
                      <img
                        src={item.cover}
                        alt={item.title}
                        title="黑料最新 预告 封面"
                        className="h-full w-full object-cover object-top"
                      />
                    </div>
                    <div className="flex min-w-0 flex-1 flex-col">
                      <div className="flex flex-wrap items-center gap-2 font-label text-xs">
                        <span className="font-medium text-primary-600">{item.issue}</span>
                        <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
                          {item.tag}
                        </span>
                      </div>
                      <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950">
                        {item.title}
                      </h3>
                      <p className="mt-2 line-clamp-2 font-body text-xs leading-relaxed text-foreground-600">
                        {item.summary}
                      </p>
                      <div className="mt-3 flex flex-wrap items-center justify-between gap-2">
                        <span className="font-label text-xs text-foreground-500">{item.eta}</span>
                        <DigButton small />
                      </div>
                    </div>
                  </article>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}